<template>
  <div class="payment">
    <div class="spelling">
       <div class="image-text">
         <div class="left">
           <img :src="forms.shopgroup_img">
         </div>
         <div class="right">
           <p>{{forms.shopgroup_title}}</p>
           <span>{{forms.shopgroup_projectname}}</span>
         </div>
       </div>
       <div class="money">
          <div class="span1"><span class="order">订单金额：</span><span class="price">¥{{order_amount}}</span></div>
       </div>
    </div>
    <div class="wxpy">
        <div class="left">
			<img src="/img/weixinzhifu.png" width="22"/><span>微信支付</span>
		</div>
        <div class="right"><van-icon name="success" size="30" color="#09bb07"/></div>
    </div>
<van-submit-bar :price="parseFloat(order_amount)*100" button-text="立即支付" label="实际支付: " @submit="wxpay" />
  </div>
</template>

<script>
var mythis=null;
import {api_group,api_base,api_user} from '@/common/Request.js';
export default {
  data() {
    return{
      forms:{},
      order_id: '',
      order_amount: '',
      wxorderinfo:'',
      order_sn: '',
      id: '',
      openid:'',

    }
  },
  created() {
    this.getList()
    // this.wxpay()
  },
  methods: {
    getList() {
      if(this.$route.query.usergroup_shopgroupid !==undefined) {
        // this.usergroup_id = this.$route.query.usergroup_id
        this.id = this.$route.query.usergroup_shopgroupid
        this.order_amount = this.$route.query.usergroup_shopgroupjoinprice
        this.order_sn = this.$route.query.usergroup_userordersn
        // console.log("this.order_sn",this.order_sn);
        // console.log("this.order_amount",this.order_amount);

        this.order_id = this.$route.query.usergroup_userorderid
      }
      if(this.$route.query.shopgroup_id !==undefined) {
      this.id = this.$route.query.shopgroup_id
      // console.log('id',id);
      this.order_id = this.$route.query.order_id
      this.order_amount = this.$route.query.order_amount
      this.order_sn = this.$route.query.order_sn
      // console.log('this.order_amount',this.order_amount)
      }
      // console.log( this.order_id,this.order_amount)
	  api_group.shopgroup_detail(this.id).then(res=>{
        console.log('resssss',res.data)
        this.forms = res.data
        this.order_amount = res.data.shopgroup_joinprice
      })
    },
    wxpay(){
			this.openid=this.$cookies.get("wx_token");
			api_user.wxpay(this.order_sn,this.order_amount,this.$cookies.get("wx_token")).then(response => {
				console.log('111',response);
				this.wxorderinfo=response.data;
				this.callpay();
			});
    },
    callpay()
		{
			if (typeof WeixinJSBridge == "undefined"){
			if( document.addEventListener ){
				document.addEventListener('WeixinJSBridgeReady', this.jsApiCall, false);
			}else if (document.attachEvent){
				document.attachEvent('WeixinJSBridgeReady', this.jsApiCall);
				document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall);
			}
			}else{
				this.jsApiCall();
			}
    },
    jsApiCall(){
		mythis=this;
				WeixinJSBridge.invoke(
				'getBrandWCPayRequest',
				this.wxorderinfo,
				function(res){
					WeixinJSBridge.log(res.err_msg);
					if(res.err_msg=="get_brand_wcpay_request:ok")
					 {
						 api_group.group_pay(mythis.order_id,mythis.order_amount).then(response => {
						 	console.log('222',response);
              //alert(response.code);
              alert("支付成功");
							mythis.$router.push("/my_group");
						 })
					 }
					//alert(res.err_code+res.err_desc+res.err_msg);
				}
			);
		},
    // grouppay() {
    //   this.$jsonp('http://v.huazhi.cn/slim/app_v1'+'/group/group_pay/'+this.order_id+'/'+this.order_amount).then(res=>{
    //     console.log(res)
    //     // alert("购买成功")
    //     this.wxpay(res.data)
    //     this.$router.push("/my_group")
    //   })
    // },
  }
}
</script>

<style scoped>
  .payment {
    position: relative;
    background-color: #f3f3f3;
  }
    .spelling {
      margin-bottom: .625rem /* 10/16 */;
      height: 11rem /* 164/16 */;
      width: 100%;
      background-color: #fff;
      margin-bottom: .625rem /* 10/16 */;
      box-sizing: border-box;
    }
    .spellings {
      margin-top: .3125rem /* 5/16 */;
      height: 13.125rem /* 210/16 */;
      width: 100%;
      background-color: #fff;
    }
    .image-text {
      padding-top: .75rem /* 12/16 */;
      height: 7.5rem /* 120/16 */;
      width: 100%;
  	display: flex;
      /* background-color: pink; */
      border-bottom: 1px solid #f3f3f3;
    }
    .image-text .left {
      height: 5.375rem /* 86/16 */;
  	flex:0 0 50%;
      /* background-color: yellow; */
      padding-left: .9375rem /* 15/16 */;
    }
    .image-text .left img {
      width: 100%;
    }
    .image-text .right {
      height: 5.375rem /* 86/16 */;
      flex:0 0 40%;
      /* background-color: green; */
      padding-left: .625rem /* 10/16 */;
    }
    .image-text .right p {
      font-size: .875rem /* 14/16 */;
      height: 2.5rem /* 40/16 */;
    }
    .image-text .right span {
      font-size: .75rem /* 12/16 */;
      color: #A9A9A9;
    }
    .money {
      height: 2.8125rem /* 45/16 */;
      width: 100%;
      border-bottom: 1px solid #f3f3f3;
      line-height: 2.8125rem /* 45/16 */;
    }
     .money .span1 {
       float: right;
       margin-right: .9375rem /* 15/16 */;
     }
    .money .order {
      font-size: .75rem /* 12/16 */;
      color: #333333;
    }
    .money .price {
      font-size: 1.125rem /* 18/16 */;
    }
    .wxpy {
      box-sizing: border-box;
      padding-top: 0.9375rem;
  	padding-bottom: 0.9375rem;
      background-color: #fff;
  	position: relative;
  	border-bottom: solid 1px #fafafa;
    }
    .wxpy span {
      font-size: .8125rem /* 13/16 */;
    }
    .wxpy .left {
  	   /*width: 5rem /* 22/16 */;
      margin-left: 1.25rem /* 20/16 */;
    }
    
    .wxpy .left img{
  	  vertical-align: middle;
    }
    .wxpy .left span{
  	  margin-left: 0.625rem;
    }
    .wxpy .right {
      width: 1.375rem /* 22/16 */;
      height: 1.25rem /* 20/16 */;
  	top:0.625rem;
  	right:2.5rem;
  	position: absolute;
    }
    .footer {
      position: fixed;
      bottom: 0rem;
      line-height: 3.0625rem /* 49/16 */;
      height: 3.0625rem /* 49/16 */;
      width: 23.4375rem /* 375/16 */;
      font-size: .75rem /* 12/16 */;
    }
    .footer-left {
      text-align: center;
      width: 14.0625rem /* 225/16 */;
      height: 100%;
      background-color: #fff;
      float: left;
    }
    .footer-left .span1 {
      color: #666;
    }
    .footer-left .span2 {
      color: #FE5A59;
    }
    .footer-right {
      color: #fff;
      text-align: center;
      height: 100%;
      width: 9.375rem /* 150/16 */;
      background-color: #FE5A59;
      float: right;
    }
</style>
